import { graphql, useFragment } from 'react-relay';

import type { PaymentCompleted_charge$key } from './__generated__/PaymentCompleted_charge.graphql.ts';
import type { PaymentCompleted_query$key } from './__generated__/PaymentCompleted_query.graphql.ts';
import PaymentLinkCompleted from './paymentLinkCompleted/PaymentLinkCompleted.tsx';

import type { ReactNode } from 'react';

type PaymentCompletedProps = {
  query: PaymentCompleted_query$key;
  charge: PaymentCompleted_charge$key;
};

const PaymentCompleted = (props: PaymentCompletedProps): ReactNode => {
  const query = useFragment<PaymentCompleted_query$key>(
    graphql`
      fragment PaymentCompleted_query on Query {
        ...PaymentLinkCompleted_query
      }
    `,
    props.query,
  );

  const charge = useFragment<PaymentCompleted_charge$key>(
    graphql`
      fragment PaymentCompleted_charge on Charge {
        ...PaymentLinkCompleted_charge
      }
    `,
    props.charge,
  );

  return <PaymentLinkCompleted query={query} charge={charge} />;
};

export default PaymentCompleted;
